import "./Match.css";
import Sheet from "@mui/joy/Sheet";
import Stack from "@mui/joy/Stack";
import { styled } from "@mui/joy/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { FaRegWindowClose } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchJobTemplates,
  fetchTemplateFields,
  setSelectedTemplateType,
  setHeaderMapping,
} from "../../state/Match/matchSlice";
import { useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const Item = styled(Sheet)(({ theme }) => ({
  ...theme.typography["body-sm"],
  textAlign: "center",
  fontWeight: theme.fontWeight.md,
  color: theme.vars.palette.text.secondary,
  border: "1px solid",
  borderColor: theme.palette.divider,
  padding: theme.spacing(1),
  borderRadius: theme.radius.md,
}));

const MatchExisting = ({ clickToClose }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isDropdownDisabled, setIsDropdownDisabled] = useState(
    location.state?.isDropdownDisabled || false
  );
  const [warningMessage, setWarningMessage] = useState("");
  const [warningColumnCheckMessage, setWarningColumnCheckMessage] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const user_token = useSelector((state) => state.login.token);
  const selectedJobId = useSelector((state) => state.fileUpload.selectedJob.id);
  const { existingjobDetails } = useSelector((state) => state.fileUpload);

  useEffect(() => {
    dispatch(
      fetchJobTemplates({ jobTypeId: selectedJobId, token: user_token })
    );
  }, [user_token, selectedJobId, dispatch]);

  const [selectedTemplate, setSelectedTemplate] = useState({
    id: "",
    templateName: "",
  });

  const [selectedValues, setSelectedValues] = useState(existingjobDetails.fieldMapping);


  const templates = useSelector((state) => state.match.templates);

  const handleTemplateChange = (event) => {
    const selectedID = event.target.value;
    const selectedTemp = templates.find((item) => item.id === selectedID);
    if (selectedTemp) {
      setSelectedTemplate(selectedTemp);
    }
  };

  useEffect(() => {
    console.log("Template Selected: ");
    console.log(selectedTemplate);
    dispatch(setSelectedTemplateType(selectedTemplate));
  }, [selectedTemplate, dispatch]);

  const selectedTemplateId = useSelector(
    (state) => state.match.selectedTemplateType.id
  );

  useEffect(() => {
    if (selectedTemplateId !== "") {
      dispatch(
        fetchTemplateFields({
          templateId: selectedTemplateId,
          token: user_token,
        })
      );
    }
  }, [selectedTemplateId, user_token, dispatch]);

  const DBFields = useSelector((state) => state.match.templateFields);
  const columns = useSelector((state) => state.match.columnHeaders);

    useEffect(() => {
      const requiredColumns = ["Auto Match", "Manual Match", "Validation Status", "OK Status"];
      const missingColumns = requiredColumns.filter(
        (col) => !columns.includes(col)
      );
  
      if (missingColumns.length > 0) {
        setWarningColumnCheckMessage(
          `The following columns are missing: ${missingColumns.join(
            ", "
          )}. These are imperative for the matching process. Please correct and re-upload the file.`
        );
        setOpenDialog(true); 
      }
    }, [columns]);
  
    const handleDialogClose = () => {
      setOpenDialog(false);
      clickToClose()
    };

  useEffect(() => {
    if (existingjobDetails && templates.length > 0) {
      const matchingTemplate = templates.find(
        (template) => template.id === existingjobDetails.templateId
      );
      if (matchingTemplate) {
        setSelectedTemplate(matchingTemplate);
        //dispatch(setSelectedTemplateType(matchingTemplate));
      }
    }
  }, [existingjobDetails, templates]);

  // useEffect(() => {
  //   if (existingjobDetails.fieldMapping && existingjobDetails.fieldMapping.length > 0) {
  //     setSelectedValues(existingjobDetails.fieldMapping);
  //     console.log("Existing values are used")
  //     console.log(existingjobDetails.fieldMapping)
  //   }
  // }, [existingjobDetails, dispatch]);

  useEffect(() => {
    const allSelected = selectedValues.every((item) => item.column !== "");
    const templateSelected = selectedTemplate.templateName !== "";
    const columnsSelected = selectedValues.map((item) => item.column);
    const duplicates = columnsSelected.filter(
      (item, index) => columnsSelected.indexOf(item) !== index && item !== ""
    );

    const duplicateFields = selectedValues
      .filter((item) => duplicates.includes(item.column))
      .map((item) => item.dbField);

    if (duplicateFields.length > 0) {
      setWarningMessage(
        `Warning: Duplicate columns selected for fields: ${duplicateFields.join(
          ", "
        )}. `
      );
      setIsFormValid(false);
    } else {
      setWarningMessage("");
      // setIsFormValid(allSelected && templateSelected);
      setIsFormValid(templateSelected);

    }

    console.log("valid", allSelected);
  }, [selectedValues, selectedTemplate]);

  const handleSelectChange = (field, value, index) => {
    const newValues = selectedValues.map((item) =>
      item.dbField === field ? { ...item, column: value } : item
    );
    console.log("Changed Values", newValues);
    setSelectedValues(newValues);
  };

  const handleConfirmClick = () => {
    if (!selectedTemplate.templateName) {
      alert("Please select a file template.");
      return;
    }

    // const allSelected = selectedValues.every(
    //   (item) => item.column !== null && item.column !== ""
    // );
    // if (!allSelected) {
    //   alert("Please select all dropdown before submitting");
    //   return;
    // }
    dispatch(setHeaderMapping(selectedValues));
    clickToClose();
  };

  return (
    <>
      <div className="colm-header">
        <h2>COLUMN HEADER MAPPING</h2>
        <span className="close-popup" onClick={clickToClose}>
          <FaRegWindowClose />
        </span>
      </div>
      <div className="container-form">
        <div className="container-main">
          <div className="file-template-details">
            <FormControl>
              <InputLabel id="demo-simple-select-label">
                File Template
              </InputLabel>

              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="File Template"
                value={selectedTemplate.id || ""}
                onChange={handleTemplateChange}
                disabled={isDropdownDisabled}
                sx={{
                  width: 350,
                  height: 55,
                  borderRadius: "8px",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#ab1368",
                    },
                    "&:hover fieldset": {
                      borderColor: "#ab1368",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#ab1368",
                    },
                  },
                  "& .MuiSelect-select": {
                    color: "#ab1368",
                  },
                  "& .MuiSelect-icon": {
                    color: "#ab1368",
                  },
                  "& .MuiMenuItem-root.Mui-selected": {
                    color: "#ab1368",
                  },
                }}
                renderValue={(selected) => {
                  const selectedTemplate = templates.find(
                    (item) => item.id === selected
                  );
                  return selectedTemplate ? selectedTemplate.templateName : "";
                }}
              >
                {templates.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.templateName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          {selectedTemplate.templateName && (
            <div className="content-box">
              <Box sx={{ flexGrow: 1 }}>
                <Grid container>
                  <Grid item xs={12}>
                    <Item
                      sx={{ backgroundColor: "#dee3eb;", color: "#ab1368;" }}
                    >
                      MATCH THE DATABASE COLUMNS
                    </Item>
                  </Grid>
                </Grid>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "row" }}>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Stack
                    spacing={4.5}
                    sx={{
                      width: "65%",
                      marginTop: "30px",
                      align: "center",
                      marginBottom: "30px",
                    }}
                  >
                    {DBFields.map((field, index) => (
                      <Item sx={{ backgroundColor: "#f1f1f1;" }} key={index}>
                        {field.displayName}
                      </Item>
                    ))}
                  </Stack>
                </Box>

                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Stack spacing={5}>
                    {DBFields.map((field, index) => (
                      <Select
                        key={index}
                        value={selectedValues[index]?.column || ""}
                        onChange={(event) =>
                          handleSelectChange(
                            field.fieldName,
                            event.target.value,
                            index
                          )
                        }
                        sx={{
                          width: 180,
                          height: 35,
                          borderRadius: "8px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#333",
                          },
                        }}
                      >
                        {columns.map((item) => (
                          <MenuItem key={item} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                    ))}
                  </Stack>
                </Box>
              </Box>
            </div>
          )}
        </div>
        {selectedTemplate.templateName && (
          <>
            {warningMessage && (
              <p style={{ color: "#ab1368", textAlign: "center" }}>
                {warningMessage}
              </p>
            )}
            <div className="confirm-reset-container">
              <Button
                type="submit"
                variant="contained"
                sx={{
                  mt: 3,
                  mb: 2,
                  backgroundColor: "#ab1368",
                  "&:hover": {
                    backgroundColor: "#8d0e56",
                  },
                }}
                onClick={handleConfirmClick}
                disabled={!isFormValid}
              >
                CONFIRM
              </Button>
            </div>
          </>
        )}
      </div>
      {/* Dialog for missing columns */}
      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>Missing Columns</DialogTitle>
        <DialogContent>
          <DialogContentText>{warningColumnCheckMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MatchExisting;
